/*
 * @Descripttion: 
 * @version: 
 * @Author: ankeji
 * @Date: 2025-10-20 13:51:30
 * @LastEditors: ankeji
 * @LastEditTime: 2025-10-20 14:28:05
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

createApp(App).use(router).use(ElementPlus).mount('#app')
